import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";

import HomePage from '../pages/home/page';
import EnergyTodayPage from '../pages/energy-today/page';
import HistoryPage from '../pages/history/page';
import DevicesPage from '../pages/devices/page';
import ReportsPage from '../pages/reports/page';
import SettingsPage from '../pages/settings/page';
import ProfilePage from '../pages/profile/page';
import PowerFlowPage from '../pages/powerflow/page';
import EnergyPage from '../pages/energy/page';
import InverterPage from '../pages/inverter/page';
import FarmTraceDashboard from '../pages/farmtrace/dashboard/page';
import FarmTraceOperations from '../pages/farmtrace/operations/page';
import FarmTraceProfitability from '../pages/farmtrace/profitability/page';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const routes: RouteObject[] = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },

  // Protected routes – require authentication
  { path: "/powerflow", element: <ProtectedRoute><PowerFlowPage /></ProtectedRoute> },
  { path: "/energy", element: <ProtectedRoute><EnergyPage /></ProtectedRoute> },
  { path: "/inverter", element: <ProtectedRoute><InverterPage /></ProtectedRoute> },
  { path: "/home", element: <ProtectedRoute><HomePage /></ProtectedRoute> },
  { path: "/energy-today", element: <ProtectedRoute><EnergyTodayPage /></ProtectedRoute> },
  { path: "/history", element: <ProtectedRoute><HistoryPage /></ProtectedRoute> },
  { path: "/devices", element: <ProtectedRoute><DevicesPage /></ProtectedRoute> },
  { path: "/reports", element: <ProtectedRoute><ReportsPage /></ProtectedRoute> },
  { path: "/settings", element: <ProtectedRoute><SettingsPage /></ProtectedRoute> },
  { path: "/profile", element: <ProtectedRoute><ProfilePage /></ProtectedRoute> },
  { path: "/farmtrace/dashboard", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/overview", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/production", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/health", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/efficiency", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/reports", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/analytics", element: <ProtectedRoute><FarmTraceDashboard /></ProtectedRoute> },
  { path: "/farmtrace/operations", element: <ProtectedRoute><FarmTraceOperations /></ProtectedRoute> },
  { path: "/farmtrace/profitability", element: <ProtectedRoute><FarmTraceProfitability /></ProtectedRoute> },
  { path: "*", element: <NotFound /> },
];

export default routes;
